<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-form 
          @submit="onSubmit"
          @failed="onFailed"
          style="min-height: 90vh;"
      >
        <div v-for="(member,index) in row.member_list" :key="index">
          <van-divider>人员信息{{ index + 1 }}
          </van-divider>
          <van-cell-group>
            <van-cell
                readonly
                input-align="right"
                :title="'人员'+(index+1)"
                :label="member.num"
                :value="member.name"
            > 
            </van-cell>
  
            <van-field
                v-model="member.phone"
                readonly
                :rules="[{ required: true,message:'请输入正确的手机号'}]"
                error-message-align="right"
                label="手机"
                input-align="right"
                clearable
                placeholder="请输入手机"
            /> 

            <van-cell center title="是否需要接站"  >
              <template #right-icon>
                <van-switch  v-model="member.need_jie" active-color="#ffad19" :active-value="1" :inactive-value="2"
                            size="24"/>
              </template>
            </van-cell>  


            <van-field 
            v-if="member.need_jie==1"
                    readonly
                    clickable
                    label="接站时间"
                    input-align="right"
                    error-message-align="right"
                    placeholder="请选择接站时间"
                    v-model="member.jie_date"
                    :rules="[{ required: true, message: '请选择接站时间' }]"
                    @click="thisMemberIndex=index;showJieDate = true" />
 

            <van-popup v-model="showJieDate" position="bottom">

              <van-datetime-picker
                      type="datetime"
                      title="选择年月日"
                      v-model="currentJieDate"
                      :min-date="minDate"
                      :max-date="maxDate"
                      @confirm="onJieDateConfirm"
                      @cancel="showJieDate=false"
              />
            </van-popup>

            <van-field
            v-if="member.need_jie==1"
                v-model="member.jie_code"
                label-width="10em"
                :rules="[{ required: true,message:'请输入车次/航班号'}]"
                error-message-align="right"
                label="接站车次/航班号" 
                input-align="right"
                clearable
                placeholder="请输入车次/航班号"
            /> 

                <div 
            v-if="member.need_jie==1" class="operate-desc-left"  >海口美兰机场接站航班号</div>


            <van-field
                v-if="member.need_jie==1"
                v-model="member.jie_count"
                label-width="10em" 
                 
                error-message-align="right"
                label="接站额外同行人数"
                input-align="right"
                clearable
                @click="Toast('人数不可修改')"
                placeholder="请输入接站额外同行人数"
            /> 



            <van-cell center title="是否需要送站"  >
              <template #right-icon>
                <van-switch  v-model="member.need_song" active-color="#ffad19" :active-value="1" :inactive-value="2"
                            size="24"/>
              </template>
            </van-cell>  


            <van-field 
            v-if="member.need_song==1"
                    readonly
                    clickable
                    label="送站时间"
                    input-align="right"
                    error-message-align="right"
                    placeholder="请选择送站时间"
                    v-model="member.song_date"
                    :rules="[{ required: true, message: '请选择送站时间' }]"
                    @click="thisMemberIndex=index;showSongDate = true" />

            <van-popup v-model="showSongDate" position="bottom">
              <van-datetime-picker
                      type="datetime"
                      title="选择年月日"
                      v-model="currentSongDate"
                      :min-date="minDate"
                      :max-date="maxDate"
                      @confirm="onSongDateConfirm"
                      @cancel="showSongDate=false"
              />
            </van-popup>
            
                <div
            v-if="member.need_song==1" class="operate-desc-left"  >从酒店出发海口美兰机场的时间</div>


            <van-field
            v-if="member.need_song==1"
                v-model="member.song_code"
                label-width="10em"
                :rules="[{ required: true,message:'请输入车次/航班号'}]"
                error-message-align="right"
                label="送站车次/航班号" 
                input-align="right"
                clearable
                placeholder="请输入车次/航班号"
            /> 

                <div
            v-if="member.need_song==1" class="operate-desc-left"  >海口美兰机场送站航班号</div>

            <van-field
                v-if="member.need_song==1"
                v-model="member.song_count"
                label-width="10em" 
                error-message-align="right"
                label="送站额外同行人数"
                input-align="right"
                
                @click="Toast('人数不可修改')"
                clearable
                placeholder="请输入送站额外同行人数"
            />
 
          </van-cell-group>
  

        </div>

 
        <div style="height: 100px"></div>

        <div class="savebtn"> 
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="confirm">
            确认无误
          </van-button>

          <van-button
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            修改并保存
          </van-button>
        </div>
      </van-form>
    </van-pull-refresh> 


    <van-dialog
            v-model="showDialog" 
    >
        <div class="wxdialog" style="text-align:center;padding:10px" >
            <img style="width:100%" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230328/user-0/20230328/4134444823f75613969212acb0adde7c.png" /> 
            长按加好友修改信息
        </div>
    </van-dialog>

    <van-popup v-model="showServiceTypePicker" v-if="row.member_list.length>0" position="bottom">
      <van-picker :columns="serviceTypeColumns"
                  show-toolbar
                  :default-index="row.member_list[thisMemberIndex].serviceType-1"
                  @cancel="showServiceTypePicker = false"
                  @confirm="onServiceConfirm"
      />
    </van-popup>

 
 
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 30px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
  display: inline-block;
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  ImagePreview
} from 'vant';
    import PayDialog from '@/components/PayDialog.vue';
 


Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button).use(Dialog);
export default {
  name: 'HuiyiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
            PayDialog,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      playMusicUrl: '',
      showJieDate: false,
      showDialog: false,
      showSongDate: false,
      minDate: new Date(2023, 2, 20),
      maxDate: new Date(2023, 3, 10),
      currentJieDate: new Date(2023, 2, 28,12,0,0),
      currentSongDate: new Date(2023, 3, 2,12,0,0),
      thisMemberIndex: 0,
      saveLoading: false,
      isLoading: false,
      showNumTypePicker: false,
      showServiceTypePicker: false,
      addShow: false,
      show_share_panel: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      showTemplate: false,
        payDialogShow:false,
      areaList: {},
      thismember: {},
      copy_text: 'cccc',
      areaValue: '',
      orderIds:[],
      submitType: '',
      subject_name: '',
      subjectArray: [],
      stationList: [],
      row: {
        id: 0,
        member_list: [],
        service_options: [],
        extra_field: [],
      },
      formData: {
        name: '11',
        num: '222',
        cardtype: 2,
        footsize: '',
        csize: '',
        is_join_exame: 2,
        join_exame_name: '',
        numTypeName: '身份证',
      },

      fSizeShow: false,
      cSizeShow: false,
      cSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
      fSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
    }
  },
  filters: {},
  mounted() {
    document.title = '接送站信息确认';

    let that = this;
    that.areaList = area;
    that.row.id = this.$route.query.id;
    if (that.row.id) {
      this.fetch();
      
    } 
    setTimeout(() =>{
      //  this.onMemberSubmit({})
    })
  },
  watch: {
    formData() {
    }
  },
  computed: {
    serviceTypeColumns() {
      // console.log('this.row.member_list', this.row.member_list)
      return this.row.member_list[this.thisMemberIndex].service_options.map(item => {
        return item.name + '(¥' + item.price + ')';
      })
    }

  },
  destroyed() {
  },
  methods: {
    fieldclick(field){
      if(typeof field.pics !='undefined'){
        if(field.pics.length>0){
          this.cSizePicList = field.pics
          this.cSizeShow=true 
        }
      }
    },
    onQuestion() {
      console.log('onQuestion')
    },


    onJieDateConfirm(date){
      console.log('onJieDateConfirm',date);
      this.showJieDate = false;
      this.row.member_list[this.thisMemberIndex].jie_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
    },

    onSongDateConfirm(date){
      console.log('onSongDateConfirm',date);
      this.showSongDate = false;

      this.row.member_list[this.thisMemberIndex].song_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
    },
    onRefresh() {
      setTimeout(() => {
        Toast('刷新成功');
        this.fetch()
      }, 800);
    },

    onMemberAdd() {
      this.addShow = true;
      this.formData = {
        name: '',
        num: '',
        cardtype: 1,
        footsize: '',
        csize: '',
        is_join_exame: 2,
        join_exame_name: '',
        numTypeName: '身份证',
      };
    },
    memberRemove(item, index) {
      let that = this;
      let notice = '确认删除' + item.name + '(' + item.num + ')' + '吗?';
      Dialog.confirm({
        title: '确认',
        message: notice
      })
          .then(() => {
            // on confirm
            console.log('subjectRemove');
            if (!item.id) {
              that.row.member_list.splice(index, 1);
              return
            }
            that.$api.post('/api/huiyi/memberDelete', {
              'baoming_id': that.row.id,
              'member_id': item.id
            }, (res) => {
              that.row.member_list.splice(index, 1);
            }, (res) => {
              Toast.fail(res.msg);
            })

          })
          .catch(() => {
            // on cancel
          });
    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onServiceConfirm(value, index) {
      this.row.member_list[this.thisMemberIndex].serviceName = value;
      this.row.member_list[this.thisMemberIndex].serviceType = index + 1;
      this.showServiceTypePicker = false;
    },
    confirm() {  
      let that = this;
      that.$api.post('/api/huiyi/jiesongConfirm', { 
        baoming_id: that.row.id
      }, (res) => {
        that.saveLoading = false; 
        Toast.success('信息确认成功');
        setTimeout(() =>{ 
          rbLink({
            name: 'HuiyiApplyList'
          }, 'back')
        },1000)

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })


    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true; 
 

      let no_need_member_list = that.row.member_list.filter(item => { 
             return (item.need_jie!=1 && item.need_song!=1 )
      })
      if(no_need_member_list.length == that.row.member_list.length){
        Toast('请至少配置一个需要接送的人员');
        return;
      }

      console.log('no_need_member_list',no_need_member_list)
      console.log('that.row.member_list',that.row.member_list)

      // that.saveLoading = true;
 
      // return ;
      that.$api.post('/api/huiyi/jiesongConfirmSave', {
        'baoming_id': that.row.id,
        'member_list': that.row.member_list.map(item => {
          return {
            'id': item.id,
            'need_jie': item.need_jie,
            'jie_code': item.jie_code,
            'jie_date': item.jie_date, 
            'need_song': item.need_song,
            'song_code': item.song_code,
            'song_date': item.song_date, 
            'song_count': item.song_count, 
            'jie_count': item.jie_count, 
          }
        })
      }, (res) => {

        that.saveLoading = false;

      Toast.success('保存成功，如无修改请点击确认无误');
      // return ;

        // that.orderIds = res.data.ids;
        // that.payDialogShow = true;

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      },true)
    },
    jumToOld(id) {
      rbLink({
        name: 'HuiyiApplyList'
      }, 'replace')
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    goPre() {
      let that = this;
      rbLink({
        name: 'HuiyiApplyFormStep1',
        query: {
          id: that.row.id
        }
      }, 'replace')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/huiyi/step2detail', {
        id: that.row.id
      }, (res) => {
        that.row = res.data;
        // that.cSizePicList = res.data.clothes_pics
        that.row.member_list.map(item => {
          item.service_options.map((service, sindex) => {
            if (item.service_id == service.id) {
              that.$set(item, 'serviceType', sindex + 1);
              that.$set(item, 'serviceName', service.name);
              return;
            }
          });
          that.row.extra_field.map((field, findex) => {
            if (typeof item.jsondata[field.label] == 'undefined') {
              that.$set(item.jsondata, field.label, '');
              item.jsondata[field.label] = '';
            }
          });

        })

        that.isLoading = false;

      }, (res) => {
        Toast.fail(res.msg);
      })
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    },

            onPaySuccess() {
                let that = this;
                console.log('onPaySuccess 支付成功');
 
                that.payDialogShow = false;

                rbLink({
                    name:'HuiyiApplyList'
                },'replace') 

            },
            onPayClose() {
                let that = this;
                console.log('onPayClose 支付关闭');
                that.payDialogShow = false;
 
                rbLink({
                    name:'HuiyiApplyList'
                },'replace')
            },
            onPayError(){
                let that = this;
                console.log('onPayClose 支付失败');
                that.payDialogShow = false;
 

                rbLink({
                    name:'HuiyiApplyList'
                },'replace')
            },


    picShow(index, list) {
      ImagePreview({
        images: list,
        startPosition: index,
      });
    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },
    Toast(msg){
      Toast(msg);
    },

    download() {
      appEvent({
        name: 'downloadFile',
        query: {
          name: '训练营报名批量导入表模版',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-21/1626854723732285.xlsx'
        }
      });
    },

  }
}
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStepJiesongConfirm.vue?60cacd7a